import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consentimiento-datos',
  templateUrl: './consentimiento-datos.component.html',
  styleUrls: ['./consentimiento-datos.component.scss']
})
export class ConsentimientoDatosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
